<template>
  <div id="app">
    <!-- <Header></Header> -->
    <Menu/>
    <router-view />
  </div>
</template>

<script>
import Header from "./components/header.vue";
import Menu from "./components/menu.vue";

export default {
  name: "App",
  components: {
    Header,
    Menu,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue